import { render, staticRenderFns } from "./GetConsentDetailDashbord.vue?vue&type=template&id=8d5b2c22&scoped=true&"
import script from "./GetConsentDetailDashbord.vue?vue&type=script&lang=js&"
export * from "./GetConsentDetailDashbord.vue?vue&type=script&lang=js&"
import style1 from "./GetConsentDetailDashbord.vue?vue&type=style&index=1&id=8d5b2c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b2c22",
  null
  
)

export default component.exports